export const CUSTOMER_SERVICE_HELP_CENTER_URL = 'https://plateformelaureat.zendesk.com/hc/fr';
